import React, { Component } from 'react';
import Footer from '../../parts/Footer';
import { Button } from 'react-bootstrap';
import Card from '../../parts/Card Merch/index';
import DataCard from '../../json/dataCardMerch.json';

class ProductPage extends Component{
    render() {
        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb ml-2 bg-transparent">
                        <li class="breadcrumb-item"><a class="text-dark" href="#">Merchandise</a></li>
                        <li class="breadcrumb-item"><a class="text-dark" href="#">Baju</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Contoh Baju</li>
                    </ol>
                </nav>

                <h2>Contoh Baju</h2>
                <div class="container mt-4">
                    <div class="row justify-content-center">
                        <div class="col-sm-7 p-5 mx-5 m-sm-2 rounded-lg bg-secondary"><h2>foto</h2></div>
                        <div class="col-sm-5 row justify-content-center">
                            <div class="col-5 col-sm-12 p-5 m-sm-2 m-2 rounded-lg bg-secondary"><h2>foto 2</h2></div>
                            <div class="col-5 col-sm-12 p-5 mb-sm-2 ml-sm-2 mr-sm-2 mt-sm-0 ml-0 mt-2 mb-2 mr-2 rounded-lg bg-secondary"><h2>foto 3</h2></div>
                        </div>
                    </div>

                    <div class="row mt-5 justify-content-between">
                        <div class="col-sm-6 mx-5 m-sm-2 p-0">
                            <h4>Deskripsi</h4>
                            <p>Commodo eu et mollit qui deserunt proident consectetur do. Eu exercitation veniam sint fugiat ex incididunt sit nisi magna. 
                                Aliquip amet eiusmod officia ad anim ullamco irure quis ullamco sunt nulla. Qui amet est officia veniam minim tempor. 
                                Do sit mollit Lorem voluptate culpa.
                            </p>
                        </div>
                        <div class="col-sm-5 m-5 m-sm-2 p-0 row justify-content-center">
                            <h5 class="col-12 ml-5">Price</h5>
                            <h5 class="col-12 ml-5"><span class="price">Rp200.000</span> per item</h5>
                            <div class="row col-12 text-center my-1 justify-content-center">
                                <div class="col-2 rounded-left bg-danger">-</div>
                                <div class="col-5 border">1 item</div>
                                <div class="col-2 rounded-right bg-success">+</div>
                            </div>
                            <div class="col-12 text-center">
                                <Button className="shadow btn btn-primary w-75 my-1">Add to cart</Button>
                                <Button className="shadow btn btn-secondary w-75 my-1">Checkout</Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid px-5">
                    <h4 class="">Similar Product</h4>
                    <div class="scrolling-wrapper row flex-row flex-nowrap my-3 py-4">
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

export default ProductPage;